import Fitting from '@/models/Fitting';
import FittingSession from '@/models/FittingSession';

export default class SetFittingSessionId
{
    /** Vue Object. */
    v = null;

    /** @type {"right"|"left"} */
    side = null;

    constructor(v, side)
    {
        this.v = v;
        this.side = side;
    }

    async handle()
    {
        /** @type {Fitting} */
        const fitting = this.v.$store.getters['lensOrder/getFitting'](this.side);
        if(!fitting)
        {
            return true;
        }

        if(fitting.session_id)
        {
            console.log(`Session ID already set for ${this.side} side: ${fitting.session_id}`);
            return true;
        }

        // Set fitting session ID if missing
        const eid = this.v.$store.state.account.cEntity.id;
        fitting.session_id = await FittingSession.create(eid);
        console.log(`Created new session ID for ${this.side} side: ${fitting.session_id}`);

        return true;
    }
}
